import type React from "react"
import { useRef } from "react"
import { FaCamera, FaTimes } from "react-icons/fa"
import "./ImageUploader.css"

type ImageUploaderProps = {
  images: File[]
  onAdd: (files: File[]) => void
  onRemove: (index: number) => void
  maxImages?: number
}

export const ImageUploader: React.FC<ImageUploaderProps> = ({
  images,
  onAdd,
  onRemove,
  maxImages = 10,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const fileList = Array.from(e.target.files)
      // Check max limit
      const remainingSlots = maxImages - images.length
      const filesToAdd = fileList.slice(0, remainingSlots)
      
      if (filesToAdd.length > 0) {
        onAdd(filesToAdd)
      }
      
      // Reset input
      if (fileInputRef.current) {
        fileInputRef.current.value = ""
      }
    }
  }

  const handleAddClick = () => {
    if (images.length >= maxImages) {
      alert(`최대 ${String(maxImages)}장까지만 업로드 가능합니다.`)
      return
    }
    fileInputRef.current?.click()
  }

  return (
    <div className="image-uploader-container">
      <div className="image-grid">
        <button className="image-add-btn" onClick={handleAddClick} type="button">
          <FaCamera size={20} />
          <span className="image-add-count">
            {String(images.length)}/{String(maxImages)}
          </span>
        </button>
        
        {images.map((file, index) => (
          <div key={`${file.name}-${String(index)}`} className="image-item">
            <img 
                src={URL.createObjectURL(file)} 
                alt={`preview-${index}`} 
                onLoad={(e) => { URL.revokeObjectURL(e.currentTarget.src); }}
            />
            <button
              className="image-remove-btn"
              onClick={(e) => {
                e.stopPropagation()
                onRemove(index)
              }}
              type="button"
            >
              <FaTimes />
            </button>
          </div>
        ))}
      </div>
      <input
        type="file"
        multiple
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="image-input"
      />
    </div>
  )
}
